import { createWebHistory, createRouter } from "vue-router";
import appConfig from "../../app.config";
import store from '@/state/store';

// Route Imports
import guest from "./routes/guest";
import main from "./routes/main";

const routes = [...guest, ...main];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"]
  const userType = store.state.auth.user.user_type
  const requiresAuth = to.meta.requiresAuth === true
  const allowedRoles = to.meta.roles

  // Not authenticated
  if (requiresAuth && !isAuthenticated) {
    return next("/login")
  }

  if (
    isAuthenticated &&
    (to.path === "/login" || to.path === "/register")
  ) {
    return next("/dashboard")
  }

  // Role-based access control
  if (requiresAuth && allowedRoles && !allowedRoles.includes(userType)) {
    return next("/dashboard") 
  }

  next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
           
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }

  document.title = routeTo.meta.title + " | " + appConfig.title;
  next();
});

export default router;
